module.exports = __webpack_public_path__ + "static/img/2017.af9ca37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2017.jpg
// module id = S9ei
// module chunks = 1